// extracted by mini-css-extract-plugin
export default {"modal":"pX-z","overlay":"qX-z","outfitSelector":"rX-z","outfitHeading":"sX-z","itemContainer":"tX-z","item":"uX-z","selected":"vX-z"};